import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';
const { off_white, dark_blue_1 } = appPalette.colors;

export const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  badgeContainer: {
    borderTop: `0.25rem solid ${off_white}`,
    padding: '0.625rem 0',
    boxShadow: 'none',
    '&:before': {
      backgroundColor: 'transparent',
    },
  },
  badge_title: {
    ...(theme.themeName === 'honda' && {
      color: dark_blue_1,
    }),
  },
  badge_description: {
    ...(theme.themeName === 'honda' && {
      lineHeight: '1.25rem',
    }),
  },
  badgeImage: {
    height: 'auto',
    width: '3.75rem',
    marginRight: '0.625rem',
    ...(theme.themeName === 'honda' && {
      marginRight: '1.25rem',
    }),
  },
  badgeHeader: {
    '& .MuiAccordionSummary-content': {
      marginRight: '1.875rem !important',
      alignItems: 'center',
    },
    '&.Mui-focused': {
      outline: 'solid 0.125rem black',
    },
  },
  badgeIcon: {
    position: 'absolute',
    right: '1.25rem',
  },
});
